export default {
  namespaced: true,
  hikvision_master_accounts: {
    title: "hikvision Conta Mestra | hikvision Conta Mestras",
    name: "nome",
    ip: "IP",
    app_key: "chave do aplicativo",
    app_secret: "chave secreta do aplicativo",
    port: "porta",
    dvrs: "DVR'S",
    syncSuccess: "sync success",
    syncDvrs: "Sincronizar DVR'S",
    admin_url: "Link de administração",
    hls_url: "Ligação HLS",
    websocket_url: "Ligação Websocket"
  },
};
